import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
  useTranslate,
} from 'react-admin';
import { InputAdornment } from '@mui/material';

export default function ResourceEdit(props: any) {
  const t = useTranslate();

  return (
    <Box style={styles.boxStyle}>
      <Edit sx={styles.editStyle} {...props}>
        <SimpleForm>
          <TextInput source='name' sx={styles.inputStyle} />

          <ReferenceInput source='countryId' reference='country'>
            <SelectInput optionText='name' sx={styles.inputStyle} />
          </ReferenceInput>

          <NumberInput
            source='price'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='minWeight'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('g')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='maxWeight'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('g')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='fromOrderPrice'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='toOrderPrice'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <BooleanInput source='isActive' sx={styles.inputStyle} />
          <BooleanInput source='isDefault' sx={styles.inputStyle} />
        </SimpleForm>
      </Edit>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editStyle: {
    width: '50%',
    minWidth: 200,
  },
  inputStyle: {
    width: '100%',
  },
};
